import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { MINI_GAMES } from './index';

// A little diversion — the same games shown while the engine evaluates, plus a couple more. The tab
// strip lets you switch games without leaving; each game keeps its own state until the modal closes.
export default function MiniGamesModal(props: {
  show: boolean;
  onHide: () => void;
}): React.ReactNode {
  const [activeId, setActiveId] = useState<string>(MINI_GAMES[0].id);
  const active = MINI_GAMES.find((g) => g.id === activeId) ?? MINI_GAMES[0];
  const Active = active.Component;

  return (
    <Modal show={props.show} onHide={props.onHide} centered dialogClassName="cm-mini-modal">
      <Modal.Header closeButton>
        <Modal.Title>Mini games</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="cm-mini-tabs" role="tablist">
          {MINI_GAMES.map((g) => (
            <button
              key={g.id}
              type="button"
              role="tab"
              aria-selected={g.id === activeId}
              className={`cm-mini-tab${g.id === activeId ? ' cm-mini-tab--active' : ''}`}
              onClick={() => setActiveId(g.id)}
            >
              {g.tabLabel ?? g.name}
            </button>
          ))}
        </div>
        {/* Remount on switch so each game starts fresh when you come back to it. */}
        <Active key={activeId} />
      </Modal.Body>
    </Modal>
  );
}
